export const rows = [
  {
    rowTitle: "Timber Veneer",
    submitKey: "timber_veneer",
    options: [
      {
        key: "oak",
        submitValue: "OAK",
      },
      {
        key: "teak",
        submitValue: "TEAK",
      },
      {
        key: "walnut",
        submitValue: "WALNUT",
      },
    ],
  },
  {
    rowTitle: "Interior Theme",
    submitKey: "interior_theme",
    options: [
      {
        key: "dune",
        submitValue: "DUNE",
      },
      {
        key: "haven",
        submitValue: "HAVEN",
      },
      {
        key: "oyster",
        submitValue: "OYSTER",
      },
      {
        key: "cove",
        submitValue: "COVE",
      },
    ],
  },
  {
    rowTitle: "Feature Panel",
    submitKey: "feature_panel",
    options: [
      {
        key: "timber",
        submitValue: "TIMBER",
      },
      {
        key: "abstract",
        submitValue: "ABSTRACT",
      },
      {
        key: "fluted",
        submitValue: "FLUTED",
      },
    ],
  },
  {
    rowTitle: "Furnishings",
    submitKey: "furnishings",
    options: [
      {
        key: "kimberly",
        submitValue: "KIMBERLY",
      },
      {
        key: "balmoral",
        submitValue: "BALMORAL",
      },
      {
        key: "hamilton",
        submitValue: "HAMILTON",
      },
      {
        key: "hayman",
        submitValue: "HAYMAN",
      },
    ],
  },
];
